<template>
  <div class="card mb-1 border-0 rounded-0  letter-spacing invoice-details-box">
    <div v-if="!payData" class="bg-warning  bg-lighten-5">
      <h3>请先选择开通会员类型。</h3>
    </div>
    <div class="card-body p-20 p-sm-2 p-md-2 p-lg-20" v-else>
      <div class="d-flex justify-content-between ">
        <div class="col-lg-6">
          <!-- <b-img thumbnail fluid src="@/assets/images/register/wePay.jpg" alt="wePay')" v-if="payType == 'wechat'" width="120"/> -->
          <img :src="`http://lcsjfx.com/football//images/uploadfiles//${payData.picPath}`" alt="qr-code" class="me-10 " v-if="payType == 'wechat'"
            width="150" />
          <!-- <b-img thumbnail fluid src="@/assets/images/register/aipay.jpg" alt="aipay')" v-else width="120"/> -->
          <img src="@/assets/images/register/aipay.jpg" alt="qr-code" class="me-10 " v-else width="150" />
          <div class="d-flex  align-items-center">
            <div class="mt-2 mt-md-2 mt-lg-1 fs-md-1 fs-lg-2 " @click="payType = 'wechat'" style="cursor:pointer;">
              <img src="@/assets/images/register/wechat.png" width="16" height="16" alt="qr-code"
                class="me-10 offset-2" />


            </div>

            <div class="mt-2 mt-md-2 mt-lg-1 fs-md-1 fs-lg-2 " @click="payType = 'alpay'" style="cursor:pointer;">
              <img src="@/assets/images/register/alpay.png" width="16" height="16" alt="qr-code"
                class="me-20 offset-2" />
            </div>


          </div>
        </div>
        <div class="col-lg-5 mt-15 mt-md-20 mt-lg-0 align-items-center d-flex ">


          <span class=" fw-black mb-5 mb-sm-10 mb-lg-20 fs-18 fs-md-10 fs-lg-20 text-danger offset-1">


            实付：{{ payData.price }} 元
            <span class="me-md-5 d-block d-md-inline-block" style="text-decoration: line-through;">
                <h6>原价：{{ payData.opirce }} 元</h6>
              </span>
            <span class="d-block fs-md-15 fs-md-16 text-muted">
              
              <span class="me-md-5 d-block d-md-inline-block">
                <span class="badge bg-warning  fw-medium">已优惠：{{ payData.discountPrice }}元</span>
              </span>
            </span>
          </span>



        </div>
        <!-- <div class="col-lg-8 mt-16 mt-md-21 mt-lg-1 me-30">
          <div class="scroll-container">
            <div class="fade show active scroll-list">
              <div style="height: 10px;" class="alert alert-light d-flex align-items-center fs-md-13 fs-lg-14"
                v-for="n in 20">
                <i class="flaticon-hot-sale lh-1 fs-14 position-relative   text-danger"></i>
                用户：{{ generateRandomString(3) }}***，{{ timeList[Math.floor(Math.random() *
                timeList.length)]}}购买了{{ cardList[Math.floor(Math.random() * cardList.length)] }}！
              </div>

            </div>

          </div>


        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PayDetail",

  props: {
    payData: {}
  },

  data: function () {
    return {
      cardList: ['月卡', '季卡'],
      timeList: ['刚刚', '1个小时前', '3个小时前', '10个小时前', '三天前', '一周前'],
      payType: 'wechat'
    };
  },

  methods: {
    generateRandomString(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }

};
</script>

<style lang="css">
.scroll-container {
  overflow: hidden;
  height: 100%;
  /*设置滚动容器的高度 */
  position: relative;
}

.scroll-list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  bottom: -40px;
  /* 列表从底部开始 */
  animation: scrollUp 10s linear infinite;
  /* 定义动画 */
  height: 300%;
}

/* .scroll-list li {  
  padding: 10px;  
  border-bottom: 1px solid #ccc;  
}   */

/* 定义滚动动画 */
@keyframes scrollUp {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-100%);
    /* 根据内容调整百分比，确保完全滚出视口 */
  }
}
</style>